import * as tslib_1 from "tslib";
import * as React from 'react';
import { RemoveScroll } from "./UI";
import SideCar from './sidecar';
function ReactRemoveScroll(props) {
    return (React.createElement(RemoveScroll, tslib_1.__assign({}, props, { sideCar: SideCar })));
}
(function (ReactRemoveScroll) {
    ReactRemoveScroll.classNames = RemoveScroll.classNames;
})(ReactRemoveScroll || (ReactRemoveScroll = {}));
export default ReactRemoveScroll;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-remove-scroll/dist/es2015/Combination.js
// module id = 794
// module chunks = 0